import { useCookieConsentStore } from "@/zapi-frontend/shared/hooks/useCookieConsent";
import { cn } from "@/zapi-frontend/shared/lib/utils";

declare const __COMMIT_HASH__: string;

type TCommitHashProps = {
  className?: string;
  appearance?: "default" | "design-system";
};

export function CommitHash({ className, appearance = "default" }: TCommitHashProps) {
  const { openConfigureModal } = useCookieConsentStore();
  const isDesignSystem = appearance === "design-system";

  return (
    <div
      className={cn(
        "flex items-center justify-center gap-3 text-center",
        isDesignSystem ? "typo-caption text-muted-foreground" : "text-[14px] text-gray-500 px-2 py-1 rounded shadow-xs",
        className
      )}
    >
      <span>Version: {__COMMIT_HASH__.slice(0, 7)}</span>
      <span className={isDesignSystem ? "text-border" : "text-gray-300"}>|</span>
      <button
        onClick={openConfigureModal}
        className={cn(
          "hover:underline transition-colors",
          isDesignSystem ? "hover:text-foreground" : "hover:text-gray-700"
        )}
      >
        Cookie Settings
      </button>
    </div>
  );
}
